import React, { useState, useRef, useEffect } from "react";
import JoditEditor from "jodit-react";

const Editor = props => {
    const editor = useRef(null);

    const config = {
        readonly: false,
        useIframeResizer: false,
        language: "pt_br",
        iframe: false,
        toolbarButtonSize: "large",
        height: 800,
        autofocus: true,
        askBeforePasteHTML: false,
        askBeforePasteFromWord: false,
        uploader: {
            insertImageAsBase64URI: true
        },
        disabledPlugins:
            "addnewline,cleanhtml,clipboard,draganddrop,draganddropelement,paste,pastestorage,errormessages,formatblock,imageprocessor,imageproperties,inlinepopup,limit,media,tablekeyboardnavigation,tooltip",
        activeButtonsInReadOnly: ["source", "fullsize", "print", "about"],
        buttons: "source,|,bold,strikethrough,underline,italic,eraser,|,superscript,subscript,|,ul,ol,|,outdent,indent,|,font,fontsize,brush,paragraph,|,image,table,link,|,align,undo,redo,|,fullsize",
        enableDragAndDropFileToEditor: true,
        showCharsCounter: false,
        showWordsCounter: false,
        showXPathInStatusbar: false,
        placeholder: ""
    }

    return (
        <JoditEditor
            ref={editor}
            value={props.value}
            config={config}
            tabIndex={1}
            onBlur={newContent => localStorage.setItem("editor_conteudo", newContent)} // preferred to use only this option to update the content for performance reasons
        />
    );
};

export default Editor;
